import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Unstable_Grid2";

import {
    Button,
    Box,
    Paper,
    Menu,
    MenuItem,
    Container,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Tabs,
    Tab,
    Chip,
} from "@mui/material";
import { ReactComponent as CircleWithDotIcon } from "../../assets/svgs/circle-with-dot.svg";
import { ReactComponent as CircleIcon } from "../../assets/svgs/circle.svg";
import { ReactComponent as CircleCheckIcon } from "../../assets/svgs/circle-check.svg";

import { styled } from "@mui/material/styles";
import "./style.css";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === "light" ? "#06aed4" : "#308fe8",
    },
}));

const NavigationTab = ({
    selected,
    label,
    options,
    totalStep,
    currentStepIndex,
    hideHeading,
    orientation,
    selectedValue,
    onClick,
}) => {
    const [completedTabs, setCompletedTabs] = useState([]);
    const [currentTab, setCurrentTab] = useState("");
    const boxStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "10px",
    };
    const gridStyle = {
        borderBottom: "1px solid #EAECF0",
        background: "#FCFCFD",
    };
    const selectedStyle = {
        borderRight: "1px solid #EAECF0",
        borderLeft: "1px solid #EAECF0",
        borderBottom: "1px solid white",
        background: "white",
    };

    const getGridClass = (option, index) => {
        let style = gridStyle;
        if (option.status === "inprogress") {
            style = { ...style, ...selectedStyle };
        } else if (option.status === "completed") {
            style = { ...style, background: "#F6FEF9" };
        }

        if (index === 0) {
            return { ...style, borderLeft: "none" };
        } else if (index === options.length - 1) {
            return { ...style, borderRight: "none" };
        }

        return style;
    };

    const getCompletedTabs = () => {
        let tabs = [...completedTabs];
        if (tabs.length === 0) {
            for (let option of options) {
                if (option.value !== selectedValue.value) {
                    tabs = [...tabs, option.value];
                    break;
                } else {
                    break;
                }
            }
        } else {
            let currentTabIndex = options.findIndex((item) => item.value === selectedValue.value);
            let optionsValues = options.filter((item, index) => index < currentTabIndex).map((item) => item.value);
            for (const optionsValue of optionsValues) {
                if (tabs.indexOf(optionsValue) === -1) {
                    tabs = [...tabs, optionsValue];
                }
            }
        }

        setCompletedTabs(tabs);
    };

    const getCurrentTabs = () => {
        let tabs = [...completedTabs];
        if (tabs.indexOf(selectedValue.value) === -1) {
            setCurrentTab(selectedValue.value);
        }
    };

    useEffect(() => {
        getCompletedTabs();

        getCurrentTabs();
    }, [selectedValue]);

    const getOptions = () => {
        let selectedIndex = options.findIndex((item) => item.value === selected);

        return options.map((item, index) => {
            return {
                ...item,
                status:
                    completedTabs.indexOf(item.value) > -1
                        ? "completed"
                        : index === selectedIndex || currentTab === item.value
                        ? "inprogress"
                        : index < selectedIndex
                        ? "completed"
                        : "incomplete",
            };
        });
    };

    const getRemainingSteps = () => {
        return totalStep - currentStepIndex;
    };

    const getBadgeLabel = () => {
        return getRemainingSteps() + " left";
    };

    const getProgressValue = () => {
        if (totalStep > 0) {
            return (100 / totalStep) * (totalStep - getRemainingSteps());
        }
        return 0;
    };

    const handleClick = (index) => {
        if (options[index]?.value !== "application-pre-qualification") {
            if (completedTabs.indexOf(options[index]?.value) > -1 || currentTab === options[index]?.value) {
                onClick(options[index]?.value + ";" + options[index]?.steps[0]?.step);
            }
        }
    };

    return (
        <Card sx={{ width: "100%", p: "0" }}>
            <CardContent sx={{ width: "100%" }}>
                {!orientation && (
                    <>
                        <Tabs
                            value={selected}
                            variant="scrollable"
                            centered
                            scrollButtons="auto"
                            selectionFollowsFocus
                            aria-label="scrollable auto tabs example"
                        >
                            {getOptions().map((option, index) => (
                                <Tab
                                    className={option.status === "inprogress" ? "inprogress-tab" : ""}
                                    sx={getGridClass(option, index)}
                                    onClick={() => handleClick(index)}
                                    icon={
                                        option.status === "completed" ? (
                                            <CircleCheckIcon className="success-icon"></CircleCheckIcon>
                                        ) : (
                                            <>
                                                {option.status === "inprogress" ? (
                                                    <CircleWithDotIcon
                                                        style={{ width: "28px", height: "28px" }}
                                                        className={
                                                            selected === option.value ? "brand-icon" : "gray-icon"
                                                        }
                                                    ></CircleWithDotIcon>
                                                ) : (
                                                    <CircleIcon
                                                        style={{ width: "28px", height: "28px" }}
                                                        className={
                                                            selected === option.value ? "brand-icon" : "gray-icon"
                                                        }
                                                    ></CircleIcon>
                                                )}
                                            </>
                                        )
                                    }
                                    label={
                                        <Typography
                                            variant="h6"
                                            component="h6"
                                            color={
                                                option.status === "inprogress"
                                                    ? "primary.main"
                                                    : option.status === "completed"
                                                    ? "text.success"
                                                    : "text.secondary"
                                            }
                                            sx={{ fontWeight: selected === option.value ? "600" : "400" }}
                                        >
                                            {option.label}
                                        </Typography>
                                    }
                                ></Tab>
                            ))}
                        </Tabs>
                        {!hideHeading && (
                            <Box sx={{ p: "12px 16px" }}>
                                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                    <Grid item>
                                        <Typography color="text.primary" variant="h6" component="h6">
                                            <b>{label}</b>
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Chip sx={{ height: "26px" }} label={getBadgeLabel()} />
                                    </Grid>
                                </Grid>

                                <BorderLinearProgress
                                    sx={{ mt: "10px" }}
                                    variant="determinate"
                                    value={getProgressValue() === 0 ? 5 : getProgressValue()}
                                ></BorderLinearProgress>
                            </Box>
                        )}
                    </>
                )}
                {orientation === "vertical" && (
                    <>
                        <Tabs
                            value={selected}
                            variant="scrollable"
                            centered
                            scrollButtons="auto"
                            selectionFollowsFocus
                            aria-label="scrollable auto tabs example"
                            orientation="vertical"
                        >
                            {getOptions().map((option, index) => (
                                <Tab
                                    className={option.status === "inprogress" ? "inprogress-tab" : ""}
                                    onClick={() => handleClick(index)}
                                    sx={{
                                        ...getGridClass(option, index),
                                        maxWidth: "100%",
                                        width: "100%",
                                        justifyContent: "start",
                                        minHeight: option.status === "inprogress" ? "auto" : "auto",
                                        alignItems: option.status === "inprogress" ? "start" : "start",
                                        background: option.status === "completed" ? "#F6FEF9" : "white",
                                        borderBottom: "1px solid #EAECF0",
                                        borderRight: "1px solid white",
                                        borderLeft: "1px solid white",
                                        padding: "12px 15px 6px 15px",
                                    }}
                                    iconPosition="start"
                                    icon={
                                        option.status === "completed" ? (
                                            <CircleCheckIcon className="success-icon"></CircleCheckIcon>
                                        ) : (
                                            <>
                                                {option.status === "inprogress" ? (
                                                    <CircleWithDotIcon
                                                        style={{ width: "28px", height: "28px" }}
                                                        className={
                                                            selected === option.value ? "brand-icon" : "gray-icon"
                                                        }
                                                    ></CircleWithDotIcon>
                                                ) : (
                                                    <CircleIcon
                                                        style={{ width: "28px", height: "28px" }}
                                                        className={
                                                            selected === option.value ? "brand-icon" : "gray-icon"
                                                        }
                                                    ></CircleIcon>
                                                )}
                                            </>
                                        )
                                    }
                                    label={
                                        <Box
                                            sx={{
                                                mt: option.status === "inprogress" ? "4px" : "0px",
                                                ml: "10px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                component="h6"
                                                color={
                                                    option.status === "inprogress"
                                                        ? "primary.main"
                                                        : option.status === "completed"
                                                        ? "text.success"
                                                        : "text.secondary"
                                                }
                                                sx={{
                                                    fontWeight: selected === option.value ? "600" : "400",
                                                }}
                                            >
                                                {option.label}
                                            </Typography>
                                            {!hideHeading && selected === option.value && (
                                                <Box sx={{ width: "100%", mt: "5px" }}>
                                                    <Grid
                                                        container
                                                        justifyContent={"space-between"}
                                                        alignItems={"center"}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="text.primary"
                                                                variant="h6"
                                                                component="h6"
                                                            >
                                                                {label}
                                                            </Typography>
                                                        </Grid>
                                                        {!selectedValue?.displayAsGroupingInDesktopView && (
                                                            <Grid item>
                                                                <Chip sx={{ height: "26px" }} label={getBadgeLabel()} />
                                                            </Grid>
                                                        )}
                                                    </Grid>

                                                    {!selectedValue?.displayAsGroupingInDesktopView && (
                                                        <BorderLinearProgress
                                                            sx={{ mt: "10px" }}
                                                            variant="determinate"
                                                            value={getProgressValue() === 0 ? 5 : getProgressValue()}
                                                        ></BorderLinearProgress>
                                                    )}
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                ></Tab>
                            ))}
                        </Tabs>
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export { NavigationTab };
